<template>
  <div class="teach-overview">
    <div class="teach-overview-top">
        <div class="title">教研概况</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="teach-region">
        <div class="region-top">
            <div class="tip">
                <div class="color-tip"></div>
                区级教研
            </div>
            <div class="right-tab">
                <div class="tab-name" @click="changeTab(true)" :class="isSelectReview ? 'is-select' : ''">活动评审</div>
                <div class="line"></div>
                <div class="tab-name" @click="changeTab(false)" :class="!isSelectReview ? 'is-select' : ''">名师工作室</div>
            </div>
        </div>
        <div class="number-statistics">
            <div class="number-item">
                <div class="name">{{isSelectReview ? '活动数' : '工作室数'}}</div>
                <div class="number">8564</div>
            </div>
            <div class="number-item">
                <div class="name">{{isSelectReview ? '作品数' : '成员数'}}</div>
                <div class="number">12</div>
            </div>
        </div>
        <div class="data-list">
            <div class="data-item"  v-for="(item,index) in dataList" :key="item.id">
                <div class="left">
                    <span>{{ index + 1 }}</span>{{ item.name }}
                </div>
                <div class="right">
                    {{ item.typeName }}：{{ item.number }}
                </div>
            </div>
        </div>
        <div class="tip">
            <div class="color-tip"></div>
            常态化教研
        </div>
        <div class="teaching-info">
            <div id="teachEchartsId" style="width: 100%;height: 100%;"></div>
            <div class="activity-number">
                <div class="name">活动总数</div>
                <!-- <div class="number">692</div> -->
                <!-- :cardType="'dataSupervise'" -->
                <count-up
                    class="infor-card-count user-created-count teach-overview-number"
                    :id-name="`code_692`"
                    :end-val="692"
                    color="#38FFF3"
                    countSize="20px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
                <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
                <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
            </div>
            <div class="join-number">
                <div class="name">活动总数</div>
                <!-- <div class="number">692</div> -->
                <!-- :cardType="'dataSupervise'" -->
                <count-up
                    class="infor-card-count user-created-count teach-overview-number"
                    :id-name="`code_792`"
                    :end-val="792"
                    color="#38FFF3"
                    countSize="20px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
                <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
                <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
            </div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
import CountUp from "@/components/countUp.vue";
export default {
  name: 'teach-overview',
  components:{
    CountUp
  },
  data() {
    return {
        //是否选择活动评审
        isSelectReview:true,
        dataList:[],
        studioList:[
            {
                name:"王明名师工作室",
                number:51145,
                typeName:"活跃度"
            },
            {
                name:"朱志英名师工作室",
                number:49523,
                typeName:"活跃度"
            },
            {
                name:"刘小锋名师工作室",
                number:43864,
                typeName:"活跃度"
            },
            {
                name:"张继德名师工作室",
                number:36785,
                typeName:"活跃度"
            },
            {
                name:"赵范名师工作室",
                number:35268,
                typeName:"活跃度"
            }
        ],
        reviewList:[
            {
                name:"全区师生阅读推广活动",
                number:59640,
                typeName:"作品数"
            },
            {
                name:"区小数首届网络画板...",
                number:54623,
                typeName:"作品数"
            },
            {
                name:"上虞区小学英语教案...",
                number:51145,
                typeName:"作品数"
            },
            {
                name:"上虞区小学语文教案...",
                number:46389,
                typeName:"作品数"
            },
            {
                name:"全区第二届短视频征...",
                number:43316,
                typeName:"作品数"
            }
        ],
        phaseList:[
            {
                value:500,
                name:'小学',
                number:50
            },
            {
                value:25,
                name:'初中',
                number:250
            },
            {
                value:25,
                name:'高中',
                number:250
            }
        ]
    }
  },
  methods: {
    changeTab(value){
        this.isSelectReview = value;
        if(value){
            this.dataList = this.reviewList;
        }else{
            this.dataList = this.studioList;
        }
    },
    initEcharts(){
        let dom = document.getElementById('teachEchartsId')
        let myChart = echarts.init(dom)
        let option;
            option = {
                tooltip: {
                    trigger: 'item',
                    // show: false,
                    // 数据的显示方式
                    formatter: (param) => {
                        return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
                    }
                },
                legend: {
                    selectedMode: false, // 是否允许点击
                    top: 'bottom',
                    left: '50%',
                    itemWidth: 9, //图例标记的图形宽度
                    itemHeight: 9,
                    textStyle: {
                        color: '#ffffff',
                        borderWidth: 2
                    },
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['75%', '50%'],
                        avoidLabelOverlap: false,
                        color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                        label: {
                            show: false,
                            position: 'center',
                            formatter: (data) => {
                                return (
                                "{a|" +
                                data.data.number +
                                "%}" +
                                "\r\n" +
                                "{b|" +
                                data.data.name +
                                "}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 16,
                                    lineHeight: 20,
                                    color: "#fff",
                                    align: "center",
                                    fontWeight: "bold",
                                },
                                b: {
                                    fontSize: 12,
                                    lineHeight: 16,
                                    fontWeight: "bold",
                                    color: "#7ABFDB",
                                    align: "center",
                                },
                            },
                            backgroundColor: "transparent",
                            fontWeight: "bold",
                            fontSize: "15",
                            padding: 6,
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.phaseList
                    }
                ]
            };
            option && myChart.setOption(option)
    }
  },
  mounted() {
    this.dataList = this.reviewList;
    this.initEcharts();
  },
}
</script>
<style lang="scss" scoped>

@font-face {
    font-family: MaravaleExpanded;
    src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
}
.teach-overview{
    width: 100%;
    height: 580px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .teach-overview-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teach-region{
        .tip{
            font-size: 14px;
            font-family:  Microsoft YaHei;
            font-weight: normal;
            color: #27CDE6;
            text-align: left;
            display: flex;
            align-items: center;
            .color-tip{
                display: inline-block;
                width: 14px;
                height: 14px;
                background: linear-gradient(90deg, #09132A, #0CBCC2);
                margin-right: 5px;
            }
        }
        .region-top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
            .right-tab{
                display: flex;
                align-items: center;
                justify-content: space-around;
                .tab-name{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #2E87E3;
                    cursor: pointer;
                }
                .line{
                    height: 13px;
                    background: linear-gradient(90deg, rgba(16, 48, 109, 0.99) 1%, rgba(114, 190, 255, 0) 80%);
                    border-radius: 1px;
                    margin: 0 10px;
                    width: 1px;

                }
                .is-select{
                    font-weight: bold;
                    color: #38FFF3;
                    border-bottom: 2px solid;  
                    border-image: linear-gradient(to right, transparent, #38FFF3,transparent) 1; 
                }
            }
        }
        .number-statistics{
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 10px 0 20px;
            .number-item{
                display: inline-flex;
                align-items: center;
                margin-right: 40px;
                .name{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #7ABFDB;
                }
                .number{
                    margin-left: 5px;
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #FFFFFF;
                }
            }
            .number-item:last-child{
                margin-right: 0;
            }
        }
        .data-list{
            // padding: 0 15px;
            .data-item{
                height: 30px;
                width: 100%;
                background: linear-gradient(90deg, rgba(16,48,109,0.99) 1%, rgba(114,190,255,0) 100%);
                border-radius: 2px;
                padding: 0 10px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left{
                    font-size: 14px;
                    font-family:  Microsoft YaHei;
                    font-weight: 400;
                    color: #6EA0D3;
                    span{
                        margin-right: 15px;
                    }
                }
                .right{
                    font-size: 14px;
                    font-family:  Microsoft YaHei;
                    font-weight: 400;
                    color: #6EA0D3;
                }
            }
            
        }
        .teaching-info{
            width: 100%;
            height: 180px;
            position: relative;
            .activity-number{
                position: absolute;
                width: 115px;
                height: 65px;
                border: 1px solid #2773E6;
                border-radius: 1px;
                top: 20px;
                left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .name{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #7ABFDB;
                }
                .number{
                    font-size: 28px;
                    font-family:  Microsoft YaHei;
                    font-weight: 400;
                    color: #38FFF3;
                }
                .teach-overview-number{
                    display: inline-block;
                    height: auto !important;
                }
            }
            .join-number{
                position: absolute;
                width: 115px;
                height: 65px;
                border: 1px solid #2773E6;
                border-radius: 1px;
                top: 105px;
                left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .name{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #7ABFDB;
                }
                .number{
                    font-size: 28px;
                    font-family:  Microsoft YaHei;
                    font-weight: 400;
                    color: #38FFF3;
                }
                .teach-overview-number{
                    display: inline-block;
                    height: auto !important;
                }
            }
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>